import JSEncrypt from "jsencrypt";
import {getInfoKey} from "@constant/keyConfig";

/**********内部函数******************/
function add0(m) {
	return m < 10 ? '0' + m : m
}

function getCurrDay() {
  var aData = new Date();
  return aData.getFullYear() + "-" + add0(aData.getMonth() + 1) + "-" + add0(aData.getDate());
}

// 计算日期 date: 传入日期   diff: 日期之差，负数为今日之前，正数为今日之后
function countDate(date, diff) {
  date = Date.parse(new Date(date)) / 1000; // 转换成时间戳，返回值是ms，除1000后转化成秒
  date += (86400) * diff; // 一天是86400秒
  return new Date(parseInt(date) * 1000);
}

function parseData(date) {
  let newDate = new Date(date); // 把时间戳转换成日期
  return newDate.getFullYear() + '-'
    + add0(newDate.getMonth() + 1) + '-'
    + add0(newDate.getDate()) + ' '
    + add0(newDate.getHours()) + ":"
    + add0(newDate.getMinutes()) + ":"
    + add0(newDate.getSeconds())
}

function addDate(time,num) {
  let n = num;
  let d = '';
  if(time) {
    d = new Date(time);
  } else {
    d = new Date();
  }
  d.setDate(d.getDate() + n);
  let year = d.getFullYear();
  let mon = d.getMonth() + 1;
  let day = d.getDate();
  let s = year + "-" + (mon < 10 ? ('0' + mon) : mon) + "-" + (day < 10 ? ('0' + day) : day);
  return s;
}

/**********外部函数******************/
/*
 * 格式化时间戳内容为日期
 * @param needTime,时间戳字符串
 * @return YYYY-MM-DD
*/
function formatDatetimeToDay(needTime){
	if (needTime == undefined || needTime == "") {
		return "";
	}
	var time = new Date(parseInt(needTime));
	var y = time.getFullYear();
	var m = time.getMonth() + 1;
	var d = time.getDate();
	return y + '-' + add0(m) + '-' + add0(d);
}
/*
 * 格式化时间戳内容为日期
 * @param needTime,时间戳字符串
 * @return h:m
*/
function formatDatetimeToTime(needTime){
	if (needTime == undefined || needTime == "") {
		return "";
	}
	var time = new Date(parseInt(needTime));
	var h = time.getHours();
	var m = time.getMinutes();
	return add0(h) + ':' + add0(m);
}
/*
 * 只取年月日
 * @return YYYY-MM-DD
*/
function formatDateToDay(needTime){
	if (needTime == undefined || needTime == "") {
		return "";
	}
	var arr= needTime.split(' ')
	return arr[0];
}
//计算时间差
function  getTimeDiffer(timeStr){
	var date1=new Date(timeStr);  //开始时间
	var date2=new Date();    //结束时间
	var date3=date1.getTime()-date2.getTime()  //时间差的毫秒数
  if(date3<=0){
    return 0;
  }
	//计算出相差天数
	var years=Math.floor(date3/(24*3600*1000*365))
	var months=Math.floor(date3/(24*3600*1000*30))
	var days=Math.floor(date3/(24*3600*1000))
	//计算出小时数
	var leave1=date3%(24*3600*1000)    //计算天数后剩余的毫秒数
	var hours=Math.floor(leave1/(3600*1000))
	//计算相差分钟数
	var leave2=leave1%(3600*1000)        //计算小时数后剩余的毫秒数
	var minutes=Math.floor(leave2/(60*1000))

  var leave3=leave2%(60*1000)        //计算小时数后剩余的毫秒数
  var seconds=Math.floor(leave3/(1000))

  return days+"天--"+add0(hours)+"时--"+add0(minutes)+"分--"+add0(seconds)+"秒";
	//alert(" 相差 "+years + "年" +days+"天 "+hours+"小时 "+minutes+" 分钟"+seconds+" 秒")*/
	if(years>0){
		return years+"年前";
	}else if(months>0){
		return months+"月前";
	}else if(days>0){
		return days+"天前";
	}else if(hours>0){
		return hours+"时前";
	}else if(minutes>0){
		return minutes+"分前";
	}
}

//计算是否是新的内容，最近3天的算新的
function  getTimeIsNew(timeStr){
  timeStr = timeStr.replace(/-/g,"/");
  if(timeStr.length>10){
    timeStr = timeStr.substring(0,10)
  }
  var date1=new Date(timeStr);  //开始时间
  var date2=new Date();    //结束时间
  var date3=date2.getTime()-date1.getTime()  //时间差的毫秒数
  //计算出相差天数
  var days=Math.floor(date3/(24*3600*1000))
  if(days>3){
    return false;
  }else {
    return true;
  }
}

//计算开标截止差距天数
function  getTimeDiff(timeStr){
  var Str = timeStr.replace(/-/g,"/");
  var date1=new Date(Str);  //开标时间
  var date2=new Date();    //当前时间
  var date3=date1.getTime()-date2.getTime()  //时间差的毫秒数
  //计算出相差天数
  var days=Math.floor(date3/(24*3600*1000))
  if(days==0){
    var hours=Math.floor(date3/(3600*1000))
    if(hours==0){
      var minures = Math.floor(date3/(60*1000)) + 1
      return "<font color=\'red\'>" + minures + "</font> 分";
    }else{
      hours = hours + 1;
      return "<font color=\'red\'>" + hours + "</font> 时";
    }
  }
  else {
    days = days + 1;
    return "<font color=\'red\'>" + days + "</font> 天";
  }
}

//计算是否是新的内容，最近3天的算新的
function  getTimeStr(timeStr){
  if(timeStr.length>10){
    timeStr = timeStr.substring(0,10)
  }
  var Str = timeStr.replace(/-/g,"/");
  var date1=new Date(Str);  //开始时间
  var date2=new Date();    //结束时间
  var date3=date2.getTime()-date1.getTime()  //时间差的毫秒数
  //计算出相差天数
  var days=Math.floor(date3/(24*3600*1000))
  if(days==0){
    return "今天";
  }
  else if(days<=3){
    return days+"天前";
  } else {
    return timeStr;
  }
}

/*
* 新闻标题等超长截断+...
*/
function limitNumber(txt,txtLen) {
	var str = txt;
	if (str.length > txtLen) {
		str = str.substr(0, txtLen) + '…';
	}
	return str;
}

/*校验邮箱地址*/
function validateEmail(rule, value, callback){
  if(!value){
    callback()
  }else{
    if(new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/).test(value)){
      /*var params = {
        tableName: 'sys_user',
        fieldName: 'email',
        fieldVal: value,
        dataId: this.userId
      };
      duplicateCheck(params).then((res) => {
        console.log(res)
        if (res.success) {
          callback()
        } else {
          callback("邮箱已存在!")
        }
      })*/
      callback();
    }else{
      callback("请输入正确格式的邮箱!")
    }
  }
}

/*校验手机号码*/
function validatePhone(rule, value, callback){
  if(!value){
    callback()
  }else{
    //update-begin--Author:kangxiaolin  Date:20190826 for：[05] 手机号不支持199号码段--------------------
    /*var regExp1 = new RegExp(/(\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$/);
    var regExp2 = new RegExp(/(^([0-9]{3}-|\([0-9]{3}\))[0-9]{3}-[0-9]{4}$)/);*/
    //if(new RegExp(/^1[3|4|5|7|8|9][0-9]\d{8}$/).test(value))
    if(new RegExp(/^[\d() +-]{8,20}$/).test(value)){
      //update-end--Author:kangxiaolin  Date:20190826 for：[05] 手机号不支持199号码段--------------------
      /*var params = {
        tableName: 'sys_user',
        fieldName: 'phone',
        fieldVal: value,
        dataId: this.userId
      };
      duplicateCheck(params).then((res) => {
        if (res.success) {
          callback()
        } else {
          callback("手机号已存在!")
        }
      })*/
      callback();
    }else{
      callback("请输入正确格式的号码!");
    }
  }
}

/*校验金额*/
function validateAmount(rule, value, callback){
  if(!value){
    callback()
  }else{
    //update-begin--Author:kangxiaolin  Date:20190826 for：[05] 手机号不支持199号码段--------------------
    if(new RegExp("/^[1-9]\\d{0,5}|0)|(([1-9]\\d{0,3}|0)\\.\\d$/").test(value)){
      callback();
    }else{
      callback("请输入正确格式的金额!");
    }
  }
}

/*校验身份证号码*/
function validIdCardNumber(rule,value,callback){
  //1.判断身份证号码
  const rr = /^[1-9]\d{1}(.{13}|.{16})$/
  if(rr.test(value)){
    if(value.length==18){
      //加权因子
      let weight_factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
      // 校验位
      let check_code = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
      let idWiSum = 0
      for(let i =0; i<17 ;i++){
        idWiSum += value.substring(i,i+1)*weight_factor[i]
      }
      //计算模
      let idMod = idWiSum % 11
      let idLastCode = check_code[idMod]
      if(value[17] == idLastCode){
        //校验成功

      }
      callback(new Error('身份证最后一位校验码不正确'))
    }
  }else{
    callback(new Error('身份证仅能为15位或18位且前两位为有效行政区划代码'))
  }
}

// 获取浏览器的类型
function getBrowserInfo() {
  var explorer = navigator.userAgent;
  if (explorer.indexOf("Chrome") >= 0) {
    //Chrome
    return 1
  }
  let UA = window.navigator.userAgent;  //取得浏览器的userAgent字符串
  let msie = UA.indexOf("MSIE");
  if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
    // ie
    return 2
  }
  // 返回：其他浏览器
  return 0
}

// 检查ie浏览器是否允许 ActiveX 运行
function checkIE() {
  try {
    let SOA_V_locator = new ActiveXObject("WbemScripting.SWbemLocator");
    let SOA_V_service = SOA_V_locator.ConnectServer(".");
    return true;
    //this.isIE=true;
  } catch (e) {
    return false;
    //this.isIE=false;
    //this.isIE=true;
  }
  //return this.isIE;
}

// chrome 浏览器获取本地设备信息
function chromeGetPluginInfo() {
  return localStorage.getItem("pluginInfo");
}

// ie浏览器获取本地设备信息
function ieGetPluginInfo() {
  let tempInfo = {}
  //获取mac、cpu、disk信息
  tempInfo.M = getM()
  tempInfo.C = getC()
  tempInfo.D = getD()
  const jse = new JSEncrypt(); // 实例化一个 jsEncrypt 对象
  jse.setPublicKey(getInfoKey); // 配置公钥
  // 加密设备信息
  return jse.encrypt(JSON.stringify(tempInfo)); //加密
}

// ie浏览器获取本地设备mac地址
function getM(){
  let currentMacAddr = "";
  try{
    let SOA_V_locator = new ActiveXObject("WbemScripting.SWbemLocator");
    let SOA_V_service = SOA_V_locator.ConnectServer(".");
    let SOA_V_NETINFO = SOA_V_service.ExecQuery("SELECT * FROM Win32_NetworkAdapterConfiguration Where IPEnabled=TRUE"); //获取网络连接信息
    let SOA_V_HOSTINFO = SOA_V_service.ExecQuery("SELECT * FROM Win32_Processor"); ////CPU 信息

    let er = new Enumerator(SOA_V_NETINFO);
    let cmpmacStr = "";
    for (; !er.atEnd(); er.moveNext()) {
      let p = er.item();
      let cmp_Mac = p.MACAddress;
      cmpmacStr += cmp_Mac + ",";
    }
    //把字符串最后一个逗号替换为空格
    let str = cmpmacStr.replace(/([^,]*),([^,]*)$/g, '$1$2');
    if (str){
      currentMacAddr = str;
    }
  }catch(err){
    currentMacAddr = "";
    console.log("currentMacAddr error:" + err);
  }
  console.log("currentMacAddr:" + currentMacAddr);
  return currentMacAddr;
}

// ie浏览器获取本地设备cpu序列号
function getC(){
  let currentCpuAddr = "";
  try{
    let locator = new ActiveXObject("WbemScripting.SWbemLocator");
    let service = locator.ConnectServer(".");
    let properties = service.ExecQuery("SELECT * FROM Win32_Processor");
    let e = new Enumerator(properties);
    let p = e.item();
    let cpuSerial = p.ProcessorID;
    if (cpuSerial){
      currentCpuAddr = cpuSerial.trim();
    }
  }catch(err){
    currentCpuAddr = "";
    console.log("currentCpuAddr error:" + err);
  }
  console.log("currentCpuAddr:" + currentCpuAddr);
  return currentCpuAddr;
}

// ie浏览器获取本地设备的硬盘序列号
function getD() {
  let currentDiskAddr = "";
  try{
    let locator = new ActiveXObject("WbemScripting.SWbemLocator");
    let service = locator.ConnectServer(".");
    let properties = service.ExecQuery("SELECT * FROM Win32_DiskDrive");
    let e = new Enumerator(properties);
    let diskSerial = '';
    for (; !e.atEnd(); e.moveNext()) {
      let p = e.item();
      if (p!=null && p.serialnumber != null) {
        diskSerial = diskSerial + p.serialnumber.trim() + ",";
      }
    }
    currentDiskAddr = diskSerial;
  }catch(err){
    currentDiskAddr = "";
    console.log("currentDiskAddr error:" + err);
  }
  console.log("currentDiskAddr:" + currentDiskAddr);
  return currentDiskAddr;
}

// 获取本地设备的cpu序列号、磁盘序列号、mac等信息的方法
function getPluginInfo() {
  // 获取浏览器内核类型：chrome、ie、或其他
  let result = "";
  let browserType = getBrowserInfo()
  switch (browserType) {
    case 0:
      // 暂不支持其他浏览器内核
      break
    case 1:
      // chrome浏览器内核获取设备信息
      result = chromeGetPluginInfo();
      break;
    case 2:
      // ie浏览器内核获取设备信息
      if (!checkIE()) {
        // 要使用 IE浏览器（IE10版本及以上）上传投标文件,添加本网站为信任站点，并允许ActiveX执行
        break;
      }
      result = ieGetPluginInfo();
      break;
  }
  return result;
}

/*校验特殊字符*/
function validateCharacter(rule, value, callback){
  if(!value){
    callback()
  }else{
    if(new RegExp(/["'<>?？&]+/).test(value)){
      callback("请输入正确的格式，不允许输入\"'<>?？&字符!");
    }else{
      callback();
    }
  }
}

/*校验备注填写内容*/
function validateRemarkChar(rule, value, callback){
  let verificationChar = ["/", "null", "-","空","无"]
  let flag = true
  let failChar = ''
  for (let i = 0; i < verificationChar.length; i++){
    if (value && verificationChar[i] == value.trim()){
      flag = false
      failChar = verificationChar[i]
      break
    }else{
      flag = true
    }
  }
  if(!value){
    callback()
  }else{
    if (!flag){
      callback("请输入正确的格式，不允许只输入"+ failChar +"字符!");
    }else{
      callback();
    }
  }
}

export {
	formatDatetimeToDay, getTimeDiffer,limitNumber,getTimeDiff,
  validateEmail,validatePhone,validIdCardNumber,getTimeIsNew,getTimeStr,getCurrDay,addDate,add0,
  getBrowserInfo, checkIE, chromeGetPluginInfo, ieGetPluginInfo, getPluginInfo,countDate,parseData,
  validateCharacter,validateRemarkChar
}